import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import gdImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/GenralDen.jpg';
import cdImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/CD.jpg';
import diImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/DI.jpg';
import ldImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/LD.jpg';
import odtImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/Odt.jpg';
import onmsImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/OnmS.jpg';
import pdImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/PD.jpg';
import pdtImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/Pdt.jpg';
import ptdtImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/Ptdt.jpg';
import rctImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/Rct.jpg';
import Footer from './Footer';

// Styled components
const TopBarContainer = styled(Box)({
  position: 'relative',
  height: '300px', // Height of the top bar
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'center',
  color: 'white',
  zIndex: 1,
});

const Background = styled(Box)({
  position: 'fixed', // Fixed to create a parallax effect
  top: 0,
  left: 12,
  right: 12,
  height: '600px', // Full height of the viewport
  backgroundImage: `url(${pdImage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  zIndex: -1,
});

const Title = styled(Typography)({
  position: 'relative',
  zIndex: 2,
  fontSize: '4rem',
  textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
  marginBottom: '50px',
});

const ScrollableContent = styled(Box)({
  height: '200vh', // Height to allow scrolling
  backgroundColor: 'rgba(249, 249, 249, 1)', // Background for the scrollable area
  padding: '20px',
});


// Styled components
const Container = styled(Box)({
  padding: '40px',
  backgroundColor: '#f9f9f9',
});

const ServiceCard = styled(Paper)({
  padding: '20px',
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  borderRadius: '8px',
  flexDirection: 'column',
  transition: 'transform 0.3s',
  '&:hover': {
    transform: 'scale(1.05)',
  },
});

const AnimatedImage = styled('img')(({ slideInFrom }) => ({
  width: '100%',
  borderRadius: '8px',
  animation: `${slideInFrom} 0.5s forwards`,
  opacity: 0,
  height: 'auto',
  objectFit: 'cover',
  '@keyframes slideInLeft': {
    '0%': {
      transform: 'translateX(-100%)',
      opacity: 0,
    },
    '100%': {
      transform: 'translateX(0)',
      opacity: 1,
    },
  },
  '@keyframes slideInRight': {
    '0%': {
      transform: 'translateX(100%)',
      opacity: 0,
    },
    '100%': {
      transform: 'translateX(0)',
      opacity: 1,
    },
  },
}));


// Service Page Component
const Specialization = () => {
  const services = [
    {
      title: 'General dentistry',
      description: `At Aarogyam Dental Care, we offer a wide range of general dental services designed to meet your unique needs and ensure optimal oral health. Our experienced team of dentists is committed to providing
personalized care and utilizing the latest dental techniques to deliver
exceptional results. We offer comprehensive general dentistry
services tailored to your needs. Our experienced dentists provide
preventive care, fillings, extractions, root canals, crowns, bridges,
sealants, fluoride treatments, and more. Enjoy personalized care,
state-of-the-art technology, and a comfortable atmosphere.`,
      imageUrl: gdImage,
      reverse: false,
    },
    {
      title: 'Root Canal Treatment',
      description: `Root canal treatment is done to save and restore teeth have been
      severely damaged or infected. RCT helps relieve pain and preserve
      the natural teeth, avoiding the need for extraction.

      At Aarogyam, RCTs are performed with advanced techniques and
      modern equipment, making the procedure as comfortable and efficient
      as possible.`,
      imageUrl: rctImage,
      reverse: true,
    },
    {
      title: 'Periodontal treatments',
      description: `At Aarogyam Dental Care, our periodontists are dedicated to
      diagnosing, treating, and preventing gum disease. Gum disease, if left
      untreated, can lead to serious oral health problems, including tooth
      loss. Our goal is to provide effective treatment and help you maintain
      healthy gums and teeth.`,
      imageUrl: pdtImage,
      reverse: false,
    },
    {
      title: 'Laser dentistry',
      description: `We offer a modern, minimally invasive approach to various dental
      treatments. Using advanced laser technology, procedures such as
      teeth whitening, gum reshaping, treatment of gum diseases and
      other minor surgical procedures are performed with precision,
      reduced discomfort and faster recovery periods.`,
      imageUrl: ldImage,
      reverse: true,
    },
    {
      title: 'Prosthodontic Treatment',
      description: `Prosthodontic Treatments at Aarogyam Dental Care focus on
      restoring and replacing missing or damaged teeth to improve both
      functionality and aesthetics. The clinic offers comprehensive
      prosthodontic services including Dental Crowns, dentures, fixed
      dentures, full mouth rehabilitation performed by skilled professionals
      using the latest technologies. These treatments are tailored to meet
      the unique needs of each patient, ensuring optimal oral health and
      comfort.`,
      imageUrl: ptdtImage,
      reverse: false,
    },
    {
      title: 'Dental implants',
      description: `Dental implants are reliable and long lasting solution for missing teeth.
      It involves the placement of a titanium screw in the jaw bone, which
      acts as an artificial tooth root which are then topped with natural
      looking crowns that blend seamlessly with the surrounding teeth. It
      provides a durable, comfortable and permanent alternative to
      traditional dentures or bridges, restoring both the appearance and
      function of your dentition.`,
      imageUrl: diImage,
      reverse: true,
    },
    {
      title: 'Cosmetic Dentistry',
      description: `At Aarogyam Dental Care, we believe that a beautiful smile can boost
      your confidence and overall well-being. Our experienced cosmetic
      dentists in Hyderabad are dedicated to transforming your smile into a
      work of art. We have a range of treatments like teeth whitening,
      Veneers, Smile makeover, etc. Our team of experts ensures
      personalized cosmetic solutions tailored to each patient’s goals,
      delivering natural looking results that boost confidence and oral
      health.`,
      imageUrl: cdImage,
      reverse: false,
    },
    {
      title: 'Orthodontic treatment',
      description: `Orthodontic treatments are designed to correct misaligned teeth and
      jaws, enhancing both function and esthetics. We offer a wide range of
      orthodontic treatment options ranging from traditional braces to
      Invisalign. We provide personalized treatment plans that cater to
      each patient’s unique needs.`,
      imageUrl: odtImage,
      reverse: true,
    },
    {
      title: 'Pediatric  dentistry',
      description: `At Aarogyam Dental Care, we understand the importance of starting
      your child's dental journey early. Our pediatric dentists are dedicated
      to providing gentle, compassionate care to ensure your child's oral
      health is in excellent hands.`,
      imageUrl: pdImage,
      reverse: false,
    },
    {
      title: 'Oral and maxillofacial surgery',
      description: `Aarogyam dental care offers specialized oral surgery services to
      address various issues that require surgical intervention. These
      include wisdom tooth extractions, dental implants, corrective jaw
      surgeries and treatments for oral diseases or injuries.`,
      imageUrl: onmsImage,
      reverse: true,
    },
    
  ];

  const [isMobile, setIsMobile] = useState(false);

  const checkDeviceType = () => {
    if (window.innerWidth <= 768) {
      setIsMobile(true); // Mobile
    } else {
      setIsMobile(false); // Desktop
    }
  };

  // Set up the resize event listener when the component mounts
  useEffect(() => {
    checkDeviceType(); // Check initial screen size
    window.addEventListener('resize', checkDeviceType); // Add resize event listener

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('resize', checkDeviceType);
    };
  }, []);

  return (
      <>
      <Background />
      <TopBarContainer>
        <Title variant="h3">Our Serv</Title>
        {isMobile ? (
        <p>You are on a mobile device!</p>
      ) : (
        <p>You are on a desktop device!</p>
      )}
      </TopBarContainer>
      <ScrollableContent>
    <Container>
      {services.map((service, index) => (
        <Grid container spacing={4} key={index} style={{ marginBottom: '40px' }}>
          {service.reverse ? (
            <>
              <Grid item xs={12} md={6}>
                <ServiceCard>
                  <Typography variant="h5">{service.title}</Typography>
                    <Typography variant="body1" style={{ marginTop: '20px' }}>
                      {service.description}
                    </Typography>
                </ServiceCard>
              </Grid>
              <Grid item xs={12} md={6}>
                <AnimatedImage src={service.imageUrl} alt={service.title} slideInFrom="slideInRight" />
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={12} md={6}>
                <AnimatedImage src={service.imageUrl} alt={service.title} slideInFrom="slideInLeft" />
              </Grid>
              <Grid item xs={12} md={6}>
                <ServiceCard>
                <Typography variant="h5">{service.title}</Typography>
                    <Typography variant="body1" style={{ marginTop: '20px' }}>
                      {service.description}
                    </Typography>
                </ServiceCard>
              </Grid>
            </>
          )}
        </Grid>
      ))}
    </Container>
    </ScrollableContent>
    <Footer/>
    </>
  );
};

export default Specialization;
